export { default } from "./StructuredText";
